export const  CHANGE_PROGRESS = "CHANGE_PROGRESS"
export const  CHANGE_PROGRESS_TYPE = "CHANGE_PROGRESS_TYPE"
export const CHANGE_PROGRESS_VISITED = "CHANGE_PROGRESS_VISITED"
export const  CHANGE_PROGRESS_LASTVISITED = "CHANGE_PROGRESS_LASTVISITED"
export const  CHANGE_PROGRESS_LASTTOUCH = "CHANGE_PROGRESS_LASTTOUCH"
export const CHANGE_PROGRESS_STEP = "CHANGE_PROGRESS_STEP"
